
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../grpc"

export interface ListExamineeListByExamineeAccountIdsResponse {
    examineeResult: Array<ExamineeResult>
}

export interface ListExamineeListByExamineeAccountIdsRequest {
    examineeAccountIds: Array<number>
    client: Array<string>
}

export interface ListExaminationReportByOrganizationIdAndTypeResponse {
    examinationReportResults: Array<ExaminationReportResult>
}

export interface ListExaminationReportByOrganizationIdAndTypeRequest {
    organizationIds: Array<number>
    examinationReportType: ExaminationReportType
}

export interface GetExaminationReportPageByAccessTokenAndTypeResponse {
    examinationReportResults: Array<ExaminationReportResult>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface GetExaminationReportPageByAccessTokenAndTypeRequest {
    examinationReportType: ExaminationReportType
    clientList: Array<string>
    pageNum: number
    pageSize: number
}

export interface GetExamineeListByIdsRequest {
    examineeId: Array<number>
}

export interface GetExamineeListByIdsResponse {
    examineeResult: Array<ExamineeResult>
}

export interface DeleteExaminationRelationshipByAccountIdRequest {
    examineeId?: number
    accountId?: number
}

export interface DeleteExaminationRelationshipByAccountIdResponse {
    isDeleted: boolean
}

export interface GetExaminationReportByExamineeReportDetailIdRequest {
    examineeReportDetailId: string
}

export interface GetExaminationReportByExamineeReportDetailIdResponse {
    examinationReportResult: ExaminationReportResult
}

export interface UpdateExaminationReportByExamineeReportDetailIdRequest {
    examinationReportInfo: ExaminationReportInfo
}

export interface UpdateExaminationReportByExamineeReportDetailIdResponse {
    isUpdated: boolean
}

export interface GetExaminationReportPageByExamineeIdRequest {
    examineeId: number
    pageNum: number
    pageSize: number
}

export interface GetExaminationReportPageByExamineeIdResponse {
    examinationReportResults: Array<ExaminationReportResult>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface GetExaminationReportPageByExamineeIdAndTypeRequest {
    examineeId: number
    examinationReportType: ExaminationReportType
    pageNum: number
    pageSize: number
}

export interface GetExaminationReportPageByExamineeIdAndTypeResponse {
    examinationReportResults: Array<ExaminationReportResult>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface GetExaminationReportPageByAccountIdRequest {
    accountId?: number
    clientList: Array<string>
    pageNum: number
    pageSize: number
}

export interface GetExaminationReportPageByAccountIdResponse {
    examinationReportResults: Array<ExaminationReportResult>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface GetExaminationReportPageByAccountIdAndTypeRequest {
    accountId?: number
    examinationReportType: ExaminationReportType
    clientList: Array<string>
    pageNum: number
    pageSize: number
}

export interface GetExaminationReportPageByAccountIdAndTypeResponse {
    examinationReportResults: Array<ExaminationReportResult>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface UpdateExaminationRelationshipByIdRequest {
    examinationRelationshipId: number
    examinable: boolean
}

export interface UpdateExaminationRelationshipByIdResponse {
    done: boolean
}

export interface GetExaminationRelationshipByAccessTokenRequest {
}

export interface GetExaminationRelationshipByAccessTokenResponse {
    examinationRelationship: Array<ExaminationRelationshipResult>
}

export interface ExaminationRelationshipResult {
    id?: number
    examinerAccountId?: number
    organizationId?: number
    examinable: boolean
    examinee: ExamineeResult
}

export interface ShareExamineeRequest {
    examineeId: number
    examinable: boolean
}

export interface ShareExamineeResponse {
    done: boolean
}

export interface GetMyAllExaminersRequest {
}

export interface GetMyAllExaminersResponse {
    examinerResults: Array<ExaminerResult>
}

export interface CreateExaminerRequest {
    examinerInfo: ExaminerInfo
}

export interface CreateExaminerResponse {
    examinerId: number
}

export interface CreateExaminerByAccountIdRequest {
    examinerInfo: ExaminerInfo
}

export interface CreateExaminerByAccountIdResponse {
    examinerId: number
}

export interface AddExamineeToExaminationRelationshipRequest {
    examineeId: number
}

export interface AddExamineeToExaminationRelationshipResponse {
    isadded: boolean
}

export interface AddExamineeRequest {
    name?: string
    gender: Gender
    organizationId?: number
    birthTimeStamp?: number
    age?: number
    phone?: string
    heightScalar?: string
    heightUnit?: string
    weightScalar?: string
    weightUnit?: string
    userId?: number
    userType?: string
    examinable: boolean
    client?: string
}

export interface AddExamineeByAccountIdRequest {
    name?: string
    gender: Gender
    organizationId?: number
    creatorAccountId?: number
    birthTimeStamp?: number
    age?: number
    phone?: string
    heightScalar?: string
    heightUnit?: string
    weightScalar?: string
    weightUnit?: string
    accountId?: number
    client?: string
}

export interface AddExamineeResponse {
    examineeId: number
}

export interface AddExamineeByAccountIdResponse {
    examineeId: number
}

export interface AddExamineeMyselfRequest {
    name?: string
    gender: Gender
    organizationId?: number
}

export interface AddExamineeMyselfResponse {
    examineeId: number
}

export interface SetAccountIdForExamineeRequest {
    examineeId?: number
}

export interface SetAccountIdForExamineeResponse {
    isUpdated: boolean
}

export interface UpdateExamineeRequest {
    examineeId?: number
    name?: string
    gender: Gender
    birthTimeStamp?: number
    age?: number
    phone?: string
    heightScalar?: string
    heightUnit?: string
    weightScalar?: string
    weightUnit?: string
}

export interface UpdateExamineeResponse {
    isUpdated: boolean
}

export interface DeleteExaminationRelationshipRequest {
    examineeId?: number
}

export interface DeleteExaminationRelationshipResponse {
    isDeleted: boolean
}

export interface GetExamineeByIdRequest {
    examineeId?: number
}

export interface GetExamineeByIdResponse {
    examineeResult: ExamineeResult
}

export interface GetMyExamineeListRequest {
    organizationId?: number
    clientList: Array<string>
}

export interface GetMyExamineeListResponse {
    examinerAccountId: number
    examineeResults: Array<ExamineeResult>
}

export interface GetExamineesExaminationReportListRequest {
    examinees: Array<number>
}

export interface GetExamineesExaminationReportListByReportTypeRequest {
    examinees: Array<number>
    examinationReportType: ExaminationReportType
}

export interface ExaminationReportMapValue {
    examinationReportRelationshipResults: Array<ExaminationReportRelationshipDtoResult>
}

export interface GetExamineesExaminationReportListResponse {
    examinationReportRelationshipMapResults: Map<number, ExaminationReportMapValue>
}

export interface GetExamineesExaminationReportListByReportTypeResponse {
    examinationReportRelationshipMapResults: Map<number, ExaminationReportMapValue>
}

export interface GetMyExaminationReportListRequest {
    organizationId?: number
}

export interface GetMyExaminationReportListResponse {
    examinationReportRelationshipResults: Array<ExaminationReportRelationshipDtoResult>
}

export interface ExaminationReportRelationshipResult {
    examinationReportRelationshipId?: number
    accountId?: number
    relationship: Relationship
    examinationReportResults: ExaminationReportResult
}

export interface ExaminationReportRelationshipDtoResult {
    accountId?: number
    relationshipMap: Map<string, RelationshipDetailResult>
    examinationReportResults: ExaminationReportResult
}

export interface RelationshipDetailResult {
    examinationReportRelationshipId: number
}

export interface ExaminationReportResult {
    examinationReportId?: number
    examinerAccountId?: number
    examineeResult: ExamineeResult
    examineeReportDetailType?: string
    examineeReportDetailId?: string
    creationTimestamp?: number
    doctorAdvice?: string
    examinerResult: ExaminerResult
    organizationId?: number
}

export interface ExamineeResult {
    examineeId?: number
    name?: string
    gender: Gender
    accountId?: number
    birthTimeStamp?: number
    age?: number
    phone?: string
    heightScalar?: string
    heightUnit?: string
    weightScalar?: string
    weightUnit?: string
    creationTimestamp?: number
    userId?: number
    userType?: string
}

export interface ExaminationReportInfo {
    id?: number
    examineeId?: number
    examineeReportDetailType: ExaminationReportType
    examineeReportDetailId?: string
    organizationId?: number
    doctorAdvice?: string
    examinerId?: number
    examinerAccountId?: number
    examineeAccountId?: number
}

export interface ExaminerInfo {
    name?: string
    phone?: string
    organizationId?: number
    id?: number
    creatorAccountId?: number
}

export interface ExaminerResult {
    id?: number
    name?: string
    phone?: string
    organizationId?: number
    creatorAccountId?: number
}

export interface CreateExaminationReportRequest {
    examinationReportInfo: ExaminationReportInfo
}

export interface CreateExaminationReportResponse {
    examinationReportId: number
}

export interface UpdateExaminationReportRequest {
    examinationReportInfo: ExaminationReportInfo
}

export interface UpdateExaminationReportResponse {
    isUpdated: boolean
}

export interface GetExaminationReportByIdRequest {
    examinationReportId: number
}

export interface GetExaminationReportByIdResponse {
    examinationReportResult: ExaminationReportResult
}

export interface DeleteExaminationReportRelationshipRequest {
    examinationReportId: number
}

export interface DeleteExaminationReportRelationshipResponse {
    isDeleted: boolean
}

export interface DeleteAllExaminationReportRelationshipRequest {
    examinationReportId: number
}

export interface DeleteAllExaminationReportRelationshipResponse {
    isDeleted: boolean
}

export interface GetExamineeListByExaminerAccountIdRequest {
    examinerAccountId: number
    clientList: Array<string>
}

export interface GetExamineeListByExaminerAccountIdResponse {
    examineeResult: Array<ExamineeResult>
}

export interface AddExaminationReportRequest {
    examinationReportId: number
}

export interface AddExaminationReportResponse {
    isSucceeded: boolean
}

export enum Gender {
    GENDER_UNKNOWN = 0,
    MALE = 1,
    FEMALE = 2,
}

export enum Relationship {
    SHARED = 0,
    EXAMINER = 1,
    EXAMINEE = 2,
}

export enum ExaminationReportType {
    GAIT = 0, /* 步姿检测 */
    POSTURE = 1, /* 体态检测 */
    RUNNING = 2, /* 跑姿检测 */
    PRESSURE_DYNAMIC = 3, /* 动态压力检测 */
    PRESSURE_STATIC = 4, /* 静态压力检测 */
    MEASUREMENT_IDCARD = 5, /* 身份证测量脚长 */
    SCANNER = 6, /* 足部扫描仪 */
    PRESSURE_BALANCE = 7, /* 平衡压力检测 */
    PRESSURE_PLATE = 8, /* 压力板 */
}

/* 检测模块 */
export class ExaminationService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* region 检测人检测对象
 添加检测对象通过AccountId */
    async addExamineeByAccountId(request: AddExamineeByAccountIdRequest): Promise<AddExamineeByAccountIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/AddExamineeByAccountId"
        return await this.call(method, path, request) as AddExamineeByAccountIdResponse
    }
    
    /* 添加检测对象 */
    async addExaminee(request: AddExamineeRequest): Promise<AddExamineeResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/AddExaminee"
        return await this.call(method, path, request) as AddExamineeResponse
    }
    
    /* 添加自己为检测对象 */
    async addExamineeMyself(request: AddExamineeMyselfRequest): Promise<AddExamineeMyselfResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/AddExamineeMyself"
        return await this.call(method, path, request) as AddExamineeMyselfResponse
    }
    
    /* 获取我的检测对象列表 */
    async getMyExamineeList(request: GetMyExamineeListRequest): Promise<GetMyExamineeListResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetMyExamineeList"
        return await this.call(method, path, request) as GetMyExamineeListResponse
    }
    
    /* 将检测对象加入好友列表 */
    async addExamineeToExaminationRelationship(request: AddExamineeToExaminationRelationshipRequest): Promise<AddExamineeToExaminationRelationshipResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/AddExamineeToExaminationRelationship"
        return await this.call(method, path, request) as AddExamineeToExaminationRelationshipResponse
    }
    
    /* 分享检测人 */
    async shareExamineeByAccessToken(request: ShareExamineeRequest): Promise<ShareExamineeResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/ShareExamineeByAccessToken"
        return await this.call(method, path, request) as ShareExamineeResponse
    }
    
    /* 删除检测对象(删除的只是目前账号与该检测对象的关系) */
    async deleteExaminationRelationship(request: DeleteExaminationRelationshipRequest): Promise<DeleteExaminationRelationshipResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/DeleteExaminationRelationship"
        return await this.call(method, path, request) as DeleteExaminationRelationshipResponse
    }
    
    /* 绑定accountId */
    async setAccountIdForExaminee(request: SetAccountIdForExamineeRequest): Promise<SetAccountIdForExamineeResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/SetAccountIdForExaminee"
        return await this.call(method, path, request) as SetAccountIdForExamineeResponse
    }
    
    /* 修改检测对象信息 */
    async updateExaminee(request: UpdateExamineeRequest): Promise<UpdateExamineeResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/UpdateExaminee"
        return await this.call(method, path, request) as UpdateExamineeResponse
    }
    
    /* 获取检测对象通过检测对象id */
    async getExamineeById(request: GetExamineeByIdRequest): Promise<GetExamineeByIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExamineeById"
        return await this.call(method, path, request) as GetExamineeByIdResponse
    }
    
    /* 根据accountId查找检测对象列表 */
    async getExamineeListByExaminerAccountId(request: GetExamineeListByExaminerAccountIdRequest): Promise<GetExamineeListByExaminerAccountIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExamineeListByExaminerAccountId"
        return await this.call(method, path, request) as GetExamineeListByExaminerAccountIdResponse
    }
    
    /* 获取检验人报告列表 */
    async getExamineesExaminationReportList(request: GetExamineesExaminationReportListRequest): Promise<GetExamineesExaminationReportListResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExamineesExaminationReportList"
        return await this.call(method, path, request) as GetExamineesExaminationReportListResponse
    }
    
    /* 添加查验人 */
    async createExaminer(request: CreateExaminerRequest): Promise<CreateExaminerResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/CreateExaminer"
        return await this.call(method, path, request) as CreateExaminerResponse
    }
    
    /* 添加查验人 */
    async createExaminerByAccountId(request: CreateExaminerByAccountIdRequest): Promise<CreateExaminerByAccountIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/CreateExaminerByAccountId"
        return await this.call(method, path, request) as CreateExaminerByAccountIdResponse
    }
    
    /* 获取查验人列表 */
    async getMyAllExaminers(request: GetMyAllExaminersRequest): Promise<GetMyAllExaminersResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetMyAllExaminers"
        return await this.call(method, path, request) as GetMyAllExaminersResponse
    }
    
    /* 查看我的检测人关系（还有能否操作） */
    async getExaminationRelationshipByAccessToken(request: GetExaminationRelationshipByAccessTokenRequest): Promise<GetExaminationRelationshipByAccessTokenResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExaminationRelationshipByAccessToken"
        return await this.call(method, path, request) as GetExaminationRelationshipByAccessTokenResponse
    }
    
    /* 修改被检测人关系 */
    async updateExaminationRelationshipById(request: UpdateExaminationRelationshipByIdRequest): Promise<UpdateExaminationRelationshipByIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/UpdateExaminationRelationshipById"
        return await this.call(method, path, request) as UpdateExaminationRelationshipByIdResponse
    }
    
    /* 删除检测对象(删除的只是目前账号与该检测对象的关系) */
    async deleteExaminationRelationshipByAccountId(request: DeleteExaminationRelationshipByAccountIdRequest): Promise<DeleteExaminationRelationshipByAccountIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/DeleteExaminationRelationshipByAccountId"
        return await this.call(method, path, request) as DeleteExaminationRelationshipByAccountIdResponse
    }
    
    /* 获取检测对象通过检测对象id */
    async getExamineeListByIds(request: GetExamineeListByIdsRequest): Promise<GetExamineeListByIdsResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExamineeListByIds"
        return await this.call(method, path, request) as GetExamineeListByIdsResponse
    }
    
    /* 根据examineeAccountId和client获取Examinee列表信息 */
    async listExamineeListByExamineeAccountIds(request: ListExamineeListByExamineeAccountIdsRequest): Promise<ListExamineeListByExamineeAccountIdsResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/ListExamineeListByExamineeAccountIds"
        return await this.call(method, path, request) as ListExamineeListByExamineeAccountIdsResponse
    }
    
    /* region 检测报告
 增加一份报告 */
    async createExaminationReport(request: CreateExaminationReportRequest): Promise<CreateExaminationReportResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/CreateExaminationReport"
        return await this.call(method, path, request) as CreateExaminationReportResponse
    }
    
    /* 修改报告 */
    async updateExaminationReport(request: UpdateExaminationReportRequest): Promise<UpdateExaminationReportResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/UpdateExaminationReport"
        return await this.call(method, path, request) as UpdateExaminationReportResponse
    }
    
    /* 获取我的报告列表 */
    async getMyExaminationReportList(request: GetMyExaminationReportListRequest): Promise<GetMyExaminationReportListResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetMyExaminationReportList"
        return await this.call(method, path, request) as GetMyExaminationReportListResponse
    }
    
    /* 查询一份检测报告记录详情 */
    async getExaminationReportById(request: GetExaminationReportByIdRequest): Promise<GetExaminationReportByIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExaminationReportById"
        return await this.call(method, path, request) as GetExaminationReportByIdResponse
    }
    
    /* 分享一份报告 */
    async addExaminationReport(request: AddExaminationReportRequest): Promise<AddExaminationReportResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/AddExaminationReport"
        return await this.call(method, path, request) as AddExaminationReportResponse
    }
    
    /* 删除我的一份检测报告记录 */
    async deleteExaminationReportRelationship(request: DeleteExaminationReportRelationshipRequest): Promise<DeleteExaminationReportRelationshipResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/DeleteExaminationReportRelationship"
        return await this.call(method, path, request) as DeleteExaminationReportRelationshipResponse
    }
    
    /* 删除我作为检测对象下所有的检测报告记录（既删除包括我分享出去或别人为我检测的报告记录） */
    async deleteAllExaminationReportRelationship(request: DeleteAllExaminationReportRelationshipRequest): Promise<DeleteAllExaminationReportRelationshipResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/DeleteAllExaminationReportRelationship"
        return await this.call(method, path, request) as DeleteAllExaminationReportRelationshipResponse
    }
    
    /* 获取检验人报告列表（根据examineeId和检测类型获取检测者某一类型的报告列表） */
    async getExamineesExaminationReportListByReportType(request: GetExamineesExaminationReportListByReportTypeRequest): Promise<GetExamineesExaminationReportListByReportTypeResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExamineesExaminationReportListByReportType"
        return await this.call(method, path, request) as GetExamineesExaminationReportListByReportTypeResponse
    }
    
    /* 获取报告列表 */
    async getExaminationReportPageByAccountId(request: GetExaminationReportPageByAccountIdRequest): Promise<GetExaminationReportPageByAccountIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExaminationReportPageByAccountId"
        return await this.call(method, path, request) as GetExaminationReportPageByAccountIdResponse
    }
    
    /* 获取报告列表 */
    async getExaminationReportPageByAccountIdAndType(request: GetExaminationReportPageByAccountIdAndTypeRequest): Promise<GetExaminationReportPageByAccountIdAndTypeResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExaminationReportPageByAccountIdAndType"
        return await this.call(method, path, request) as GetExaminationReportPageByAccountIdAndTypeResponse
    }
    
    /* 获取报告列表 */
    async getExaminationReportPageByExamineeId(request: GetExaminationReportPageByExamineeIdRequest): Promise<GetExaminationReportPageByExamineeIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExaminationReportPageByExamineeId"
        return await this.call(method, path, request) as GetExaminationReportPageByExamineeIdResponse
    }
    
    /* 获取报告列表 */
    async getExaminationReportPageByExamineeIdAndType(request: GetExaminationReportPageByExamineeIdAndTypeRequest): Promise<GetExaminationReportPageByExamineeIdAndTypeResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExaminationReportPageByExamineeIdAndType"
        return await this.call(method, path, request) as GetExaminationReportPageByExamineeIdAndTypeResponse
    }
    
    /* 根据accessToken获取报告列表 */
    async getExaminationReportPageByAccessTokenAndType(request: GetExaminationReportPageByAccessTokenAndTypeRequest): Promise<GetExaminationReportPageByAccessTokenAndTypeResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExaminationReportPageByAccessTokenAndType"
        return await this.call(method, path, request) as GetExaminationReportPageByAccessTokenAndTypeResponse
    }
    
    /* 修改报告 */
    async updateExaminationReportByExamineeReportDetailId(request: UpdateExaminationReportByExamineeReportDetailIdRequest): Promise<UpdateExaminationReportByExamineeReportDetailIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/UpdateExaminationReportByExamineeReportDetailId"
        return await this.call(method, path, request) as UpdateExaminationReportByExamineeReportDetailIdResponse
    }
    
    /* 查询一份检测报告记录详情 */
    async getExaminationReportByExamineeReportDetailId(request: GetExaminationReportByExamineeReportDetailIdRequest): Promise<GetExaminationReportByExamineeReportDetailIdResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/GetExaminationReportByExamineeReportDetailId"
        return await this.call(method, path, request) as GetExaminationReportByExamineeReportDetailIdResponse
    }
    
    /* 根据组织ID和检测类型获取检测列表 */
    async listExaminationReportByOrganizationIdAndType(request: ListExaminationReportByOrganizationIdAndTypeRequest): Promise<ListExaminationReportByOrganizationIdAndTypeResponse> {
        const method = "post"
        const path = "/base.examination.ExaminationService/ListExaminationReportByOrganizationIdAndType"
        return await this.call(method, path, request) as ListExaminationReportByOrganizationIdAndTypeResponse
    }
    
}
